import { Observable } from 'rxjs';
import { Clinic, DataSourceResponse, AddNewUser, ClinicUser, ClinicInfo } from '../../models';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';



@Injectable({ providedIn: 'root' })
export class ClinicService extends ApiService {
  endPoint = '/api/clinics';
  create(model: Clinic) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}`, model);
  }
  createApplication(model: Clinic) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}/application`, model);
  }
  update(id: string, model: Clinic) {
    return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }
  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.clinicsBaseURL}${this.endPoint}/deleteRange`, ids);
  }

  get(id: string): Observable<Clinic> {
    return this.http.get<Clinic>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }

  getList(queryParams: any): Observable<DataSourceResponse<Clinic>> {
    const params = new HttpParamsEncoder().encode(queryParams);

    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}`, { params });
  }

  getClinicUsers(clinicId: string, queryParams: any): Observable<DataSourceResponse<ClinicUser>> {
    const params = new HttpParamsEncoder().encode(queryParams);

    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}/${clinicId}/users`, { params });
  }

  getPersonClinics(): Observable<ClinicInfo[]> {
    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}/person-clinics`);
  }
  getClinicBranches(): Observable<ClinicInfo[]> {
    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}/clinic-branches`);
  }

  addNewUser(id: string, tenantId: string, model: AddNewUser) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}/${id}/users/${tenantId}`, model);
  }
  toogleIsActive(id: string, isActive: boolean) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}/${id}/toogleIsActive/${isActive}`, {});
  }
  toogleIsTemplate(id: string, isTemplate: boolean) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}/${id}/toogleIsTemplate/${isTemplate}`, {});
  }
  cloneFromTemplateClinic(templateClinicId: string) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}/cloneFromTemplateClinic/${templateClinicId}`, {});
  }
  changeTrialInterval(id: string, model: any) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}/${id}/activation`, model);
  }
  changeLogo(id: string, imagePath: string) {
    return this.http.put<any>(`${this.clinicsBaseURL}${this.endPoint}/changelogo/${id}`, { "base64String": imagePath });
  }
}
